var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.696 1c-1.166 0-2.707.12-4.263.456-1.526.33-3.25.904-4.636 1.924C9.337 5.93 8 9.92 8 13.065V28.833a2.174 2.174 0 0 0 4.348 0V19.38h8.804a2.174 2.174 0 0 0 0-4.348h-8.804V13.063c0-2.072.908-4.622 3.029-6.184.68-.5 1.727-.905 2.973-1.173a16.572 16.572 0 0 1 3.346-.36 2.174 2.174 0 0 0 0-4.347z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFor);
export default __webpack_public_path__ + "static/media/FOR.03d252ffccb843058e2cdfd9d5e1859d.svg";
export { ForwardRef as ReactComponent };